<template>
  <div>
    <b-row class="border_right_info border-bottom">
      <b-col cols="12" md="12">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.select_company}: `"
            :showInfo="true"
            :showRequired="mode === 'add'"
            :titleText="$lang.profileLang.select_company_tooltip"
            :rules="$v.company_selected.$params"
          />
          <selectAsync
            :options="company_options"
            v-model="$v.company_selected.$model"
            label="name"
            :isValid="
              $v.company_selected.$dirty ? !$v.company_selected.$error : null
            "
            :loading="company_loading"
            :asyncFind="getCompanyCombo"
            :disabled="mode === 'edit'"
          />
          <b-form-invalid-feedback
            :state="
              $v.company_selected.$dirty ? !$v.company_selected.$error : null
            "
          >
            <div v-if="!$v.company_selected.required">
              {{
                $lang.error_required | replace($lang.profileLang.select_company)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.term_title}: `"
            :rules="$v.caption.$params"
          />
          <b-form-input
            v-model="$v.caption.$model"
            type="text"
            autocomplete="off"
            :state="$v.caption.$dirty ? !$v.caption.$error : null"
          />
          <b-form-invalid-feedback
            :state="$v.caption.$dirty ? !$v.caption.$error : null"
          >
            <div v-if="!$v.caption.required">
              {{ $lang.error_required | replace($lang.profileLang.term_title) }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="border_right_danger border-bottom pt-3">
      <b-col cols="12" md="12" />
      <b-col cols="12" md="6">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.start_at}: `"
            :rules="$v.start_at.$params"
          />
          <date-picker
            v-model="$v.start_at.$model"
            type="datetime"
            :state="$v.start_at.$dirty ? !$v.start_at.$error : null"
            inputReq="true"
            clearable
            format="YYYY-MM-DD HH:mm:ss"
            display-format="jYYYY/jMM/jDD ساعت HH:mm"
            :class="
              $v.start_at.$dirty
                ? $v.start_at.$error
                  ? 'invalid-date'
                  : 'valid-date'
                : null
            "
          >
          </date-picker>
          <b-form-invalid-feedback
            :state="$v.start_at.$dirty ? !$v.start_at.$error : null"
          >
            <div v-if="!$v.start_at.required">
              {{ $lang.error_required | replace($lang.profileLang.start_at) }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.end_at}: `"
            :rules="$v.end_at.$params"
          />
          <date-picker
            v-model="$v.end_at.$model"
            type="datetime"
            :state="$v.end_at.$dirty ? !$v.end_at.$error : null"
            inputReq="true"
            clearable
            format="YYYY-MM-DD HH:mm:ss"
            display-format="jYYYY/jMM/jDD ساعت HH:mm"
            :min="$v.start_at.$model | moment('YYYY-MM-DD HH:mm')"
            :class="
              $v.end_at.$dirty
                ? $v.end_at.$error
                  ? 'invalid-date'
                  : 'valid-date'
                : null
            "
          >
          </date-picker>
          <b-form-invalid-feedback
            :state="$v.end_at.$dirty ? !$v.end_at.$error : null"
          >
            <div v-if="!$v.end_at.required">
              {{ $lang.error_required | replace($lang.profileLang.end_at) }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12" v-if="mode === 'edit'">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="$lang.profileLang.status"
            :rules="$v.status_selected.$params"
            :showInfo="true"
            :titleText="$lang.profileLang.status_selected_tooltip"
          />
          <selectFind
            :options="status_options"
            v-model="$v.status_selected.$model"
            label="text"
            :isValid="
              $v.status_selected.$dirty ? !$v.status_selected.$error : null
            "
            :loading="status_loading"
          />
          <b-form-invalid-feedback
            :state="
              $v.status_selected.$dirty ? !$v.status_selected.$error : null
            "
          >
            <div v-if="!$v.status_selected.required">
              {{ $lang.error_required | replace($lang.profileLang.status) }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12">
        <b-alert show variant="info">
          <i class="fas fa-info-circle fa-lg mr-1" />
          <b v-html="twoStepAlert" />
        </b-alert>
        <b-form-group label-cols="4">
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.check_two_step_verification}: `"
            :rules="$v.check_two_step_verification.$params"
          />
          <b-form-checkbox
            v-model="check_two_step_verification"
            name="check-button"
            switch
            class="mt-2"
          >
            <b
              v-if="check_two_step_verification"
              v-text="'فعال'"
              class="text-success"
            />
            <b v-else v-text="'غیرفعال'" class="text-danger" />
          </b-form-checkbox>
          <b-form-invalid-feedback
            :state="
              $v.check_two_step_verification.$dirty
                ? !$v.check_two_step_verification.$error
                : null
            "
          >
            <div v-if="!$v.check_two_step_verification.required">
              {{
                $lang.error_required
                  | replace($lang.profileLang.check_two_step_verification)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-cols="4">
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.auto_login}: `"
            :rules="$v.auto_login.$params"
          />
          <b-form-checkbox
            v-model="auto_login"
            name="check-button"
            switch
            class="mt-2"
          >
            <b v-if="auto_login" v-text="'فعال'" class="text-success" />
            <b v-else v-text="'غیرفعال'" class="text-danger" />
          </b-form-checkbox>
          <b-form-invalid-feedback
            :state="$v.auto_login.$dirty ? !$v.auto_login.$error : null"
          >
            <div v-if="!$v.auto_login.required">
              {{ $lang.error_required | replace($lang.profileLang.auto_login) }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="border_right_success border-bottom pt-3">
      <b-col cols="12" md="12" class="mb-3">
        <b-form-group label-cols-md="2">
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.term_type}:`"
            :rules="$v.term_type_selected.$params"
          />
          <b-form-radio-group
            class="mt-2"
            v-model="$v.term_type_selected.$model"
            :options="term_type_options"
            name="term_type"
          >
            <b-form-invalid-feedback
              :state="
                $v.term_type_selected.$dirty
                  ? !$v.term_type_selected.$error
                  : null
              "
            >
              <div v-if="!$v.term_type_selected.required">
                {{
                  $lang.error_required | replace($lang.profileLang.term_type)
                }}
              </div>
            </b-form-invalid-feedback>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12" v-show="!term_type_selected">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.license_type}: `"
            :rules="$v.license_type_selected.$params"
          />
          <selectFind
            :options="license_type_options"
            v-model="$v.license_type_selected.$model"
            label="text"
            id="value"
            :isValid="
              $v.license_type_selected.$dirty
                ? !$v.license_type_selected.$error
                : null
            "
          />
          <b-form-invalid-feedback
            :state="
              $v.license_type_selected.$dirty
                ? !$v.license_type_selected.$error
                : null
            "
          >
            <div v-if="!$v.license_type_selected.required">
              {{
                $lang.error_required | replace($lang.profileLang.license_type)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12" v-show="term_type_selected">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.cooperation_type}: `"
            :rules="$v.cooperation_type_selected.$params"
          />
          <selectFind
            :options="cooperation_type_options"
            v-model="$v.cooperation_type_selected.$model"
            label="text"
            id="value"
            :isValid="
              $v.cooperation_type_selected.$dirty
                ? !$v.cooperation_type_selected.$error
                : null
            "
          />
          <b-form-invalid-feedback
            :state="
              $v.cooperation_type_selected.$dirty
                ? !$v.cooperation_type_selected.$error
                : null
            "
          >
            <div v-if="!$v.cooperation_type_selected.required">
              {{
                $lang.error_required
                  | replace($lang.profileLang.cooperation_type)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12" v-show="!term_type_selected">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.select_limit_registration}: `"
            :showInfo="true"
            :titleText="$lang.profileLang.select_limit_registration_tooltip"
            :rules="$v.limit_registration_selected.$params"
          />
          <selectAsync
            :options="limit_registration_options"
            v-model="$v.limit_registration_selected.$model"
            :loading="limit_registration_loading"
            label="caption"
            id="id"
            :multiple="true"
            :asyncFind="getTermCombo"
            :isValid="
              $v.limit_registration_selected.$dirty
                ? !$v.limit_registration_selected.$error
                : null
            "
            @removeItem="removeItemOfLimitRegistration"
          />
          <b-form-invalid-feedback
            :state="
              $v.limit_registration_selected.$dirty
                ? !$v.limit_registration_selected.$error
                : null
            "
          >
            <div v-if="!$v.limit_registration_selected.required">
              {{
                $lang.error_required
                  | replace($lang.profileLang.select_limit_registration)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.select_azmoon}: `"
            :rules="$v.azmoon_selected.$params"
          />
          <selectAsync
            :options="azmoon_options"
            v-model="$v.azmoon_selected.$model"
            label="caption"
            id="id"
            :loading="azmoon_loading"
            :multiple="true"
            :asyncFind="getAzmoonCombo"
            :isValid="
              $v.azmoon_selected.$dirty ? !$v.azmoon_selected.$error : null
            "
            @removeItem="removeItemOfAzmoonSelected"
          />
          <b-form-invalid-feedback
            :state="
              $v.azmoon_selected.$dirty ? !$v.azmoon_selected.$error : null
            "
          >
            <div v-if="!$v.azmoon_selected.required">
              {{
                $lang.error_required | replace($lang.profileLang.select_azmoon)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="border_right_warning border-bottom pt-3">
      <b-col cols="12" md="12">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.select_role_pre_parvandeh}: `"
            :rules="$v.pre_role_selected.$params"
          />
          <TreePage
            :usedInForm="true"
            :showAlertNotice="false"
            :showRoleSelected="true"
            limitSelected="1"
            :tags="pre_role_selected"
            :generateRoleSelected="generateRoleSelectedOfTreePage"
            @updateRoleSelected="updatePreRoleSelected"
          />
          <b-form-invalid-feedback
            :state="
              $v.pre_role_selected.$dirty ? !$v.pre_role_selected.$error : null
            "
          >
            <div v-if="!$v.pre_role_selected.required">
              {{
                $lang.error_required
                  | replace($lang.profileLang.select_role_pre_parvandeh)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12" class="border-top">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.select_role_final_parvandeh}: `"
            :rules="$v.final_role_selected.$params"
          />
          <TreePage
            :usedInForm="true"
            :showAlertNotice="false"
            :showRoleSelected="true"
            limitSelected="1"
            :tags="final_role_selected"
            :generateRoleSelected="generateRoleSelectedOfTreePage"
            :createdData="false"
            @updateRoleSelected="updateFinalRoleSelected"
          />
          <b-form-invalid-feedback
            :state="
              $v.final_role_selected.$dirty
                ? !$v.final_role_selected.$error
                : null
            "
          >
            <div v-if="!$v.final_role_selected.required">
              {{
                $lang.error_required
                  | replace($lang.profileLang.select_role_final_parvandeh)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="border_right_primary border-bottom pt-3">
      <b-col cols="12" md="12" class="mb-3">
        <b-form-group label-cols="3">
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.show_register_link}: `"
            :rules="$v.link_show.$params"
          />
          <b-form-checkbox
            v-model="link_show"
            name="check-button"
            switch
            class="mt-2"
          >
            <b v-if="link_show" v-text="'بله'" class="text-success" />
            <b v-else v-text="'خیر'" class="text-danger" />
          </b-form-checkbox>
          <b-form-invalid-feedback
            :state="$v.link_show.$dirty ? !$v.link_show.$error : null"
          >
            <div v-if="!$v.link_show.required">
              {{
                $lang.error_required
                  | replace($lang.profileLang.show_register_link)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
        <div v-if="mode === 'edit'">
          <b-form-group>
            <requiredComponent
              slot="label"
              :label="`${$lang.profileLang.registration_url}: `"
              :rules="$v.registrationUrl.$params"
            />
            <div
              class="border rounded d-flex align-items-center justify-content-between p-2"
            >
              <span
                @click="copy(registrationUrl, true)"
                v-b-tooltip.hover
                title="کپی"
              >
                <i class="fas fa-clipboard fa-lg text-dark cursor_pointer" />
              </span>
              <a
                :href="registrationUrl"
                target="_blank"
                v-text="registrationUrl"
              />
            </div>
          </b-form-group>
        </div>
      </b-col>
      <b-col cols="12" md="12">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.register_condition}: `"
            :rules="$v.register_condition.$params"
          />
          <editor dir="rtl" v-model="$v.register_condition.$model">
            <br />
          </editor>
          <b-form-invalid-feedback
            :state="
              $v.register_condition.$dirty
                ? !$v.register_condition.$error
                : null
            "
          >
            <div v-if="!$v.register_condition.required">
              {{
                $lang.error_required
                  | replace($lang.profileLang.register_condition)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.link_caption}: `"
            :rules="$v.link_caption.$params"
          />
          <b-form-input
            v-model="$v.link_caption.$model"
            type="text"
            autocomplete="off"
            :state="$v.link_caption.$dirty ? !$v.link_caption.$error : null"
          />
          <b-form-invalid-feedback
            :state="$v.link_caption.$dirty ? !$v.link_caption.$error : null"
          >
            <div v-if="!$v.link_caption.required">
              {{
                $lang.error_required | replace($lang.profileLang.link_caption)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12" class="mb-3">
        <b-form-group label-cols-md="2">
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.register_type}:`"
            :rules="$v.register_type_selected.$params"
          />
          <b-form-radio-group
            class="mt-2"
            v-model="$v.register_type_selected.$model"
            :options="register_type_options"
            name="register_type"
          >
            <b-form-invalid-feedback
              :state="
                $v.register_type_selected.$dirty
                  ? !$v.register_type_selected.$error
                  : null
              "
            >
              <div v-if="!$v.register_type_selected.required">
                {{
                  $lang.error_required
                    | replace($lang.profileLang.register_type)
                }}
              </div>
            </b-form-invalid-feedback>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12" v-show="register_type_selected">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.link_register_code_caption}: `"
            :rules="$v.link_register_code_caption.$params"
          />
          <b-form-input
            v-model="$v.link_register_code_caption.$model"
            type="text"
            autocomplete="off"
            :state="
              $v.link_register_code_caption.$dirty
                ? !$v.link_register_code_caption.$error
                : null
            "
          />
          <b-form-invalid-feedback
            :state="
              $v.link_register_code_caption.$dirty
                ? !$v.link_register_code_caption.$error
                : null
            "
          >
            <div v-if="!$v.link_register_code_caption.required">
              {{
                $lang.error_required
                  | replace($lang.profileLang.link_register_code_caption)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12" v-show="register_type_selected">
        <b-form-group label-cols="4">
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.link_check_national_code}: `"
            :rules="$v.link_check_national_code.$params"
          />
          <b-form-checkbox
            v-model="link_check_national_code"
            name="check-button"
            switch
            class="mt-2"
          >
            <b
              v-if="link_check_national_code"
              v-text="'مطابق باشد'"
              class="text-success"
            />
            <b v-else v-text="'مطابق نباشد'" class="text-danger" />
          </b-form-checkbox>
          <b-form-invalid-feedback
            :state="
              $v.link_check_national_code.$dirty
                ? !$v.link_check_national_code.$error
                : null
            "
          >
            <div v-if="!$v.link_check_national_code.required">
              {{
                $lang.error_required
                  | replace($lang.profileLang.link_check_national_code)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="border_right_secondary border-bottom pt-3">
      <b-col cols="12" md="12">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.profileLang.description}: `"
            :rules="$v.description.$params"
          />
          <b-form-textarea
            type="text"
            v-model="$v.description.$model"
            :rows="this.$config.form.textareaRows"
          >
          </b-form-textarea>
          <b-form-invalid-feedback
            :state="$v.description.$dirty ? !$v.description.$error : null"
          >
            <div v-if="!$v.description.required">
              {{
                $lang.error_required | replace($lang.profileLang.description)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="text-right pt-3">
        <b-button
          variant="success"
          @click="submit"
          v-if="isAdmin(parentPermissions) && $route.name !== 'view_survey'"
        >
          {{ $lang.submitButton }}
          <i class="fa fa-check"></i>
        </b-button>
        <b-button
          type="reset"
          class="ml-2"
          size="md"
          variant="danger"
          @click="close"
        >
          {{ $lang.close }}
          <i class="fa fa-ban"></i>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import editor from "@/components/ckeditor/editor";
import { pathOr, includes } from "ramda";
import { required, requiredIf, url } from "vuelidate/lib/validators";
import { renderEumOptions, isAdmin, copy } from "@/shared/utils";
import TreePage from "@/components/tree/treePage";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "register-term-form",
  validations: {
    company_selected: {
      required: requiredIf((vm) => vm.mode === "add"),
    },
    caption: { required },
    term_type_selected: { required },
    license_type_selected: {
      required: requiredIf((vm) => !vm.term_type_selected),
    },
    cooperation_type_selected: {
      required: requiredIf((vm) => vm.term_type_selected),
    },
    limit_registration_selected: {},
    pre_role_selected: { required },
    final_role_selected: { required },
    azmoon_selected: {},
    link_show: { required },
    link_caption: { required },
    register_type_selected: { required },
    link_register_code_caption: {
      required: requiredIf((vm) => vm.register_type_selected),
    },
    register_condition: {},
    link_check_national_code: {
      required: requiredIf((vm) => vm.register_type_selected),
    },
    start_at: { required },
    end_at: { required },
    status_selected: {
      required: requiredIf((vm) => vm.mode === "edit"),
    },
    check_two_step_verification: { required },
    auto_login: { required },
    description: {},
    registrationUrl: {},
  },
  components: { TreePage, datePicker: VuePersianDatetimePicker, editor },
  props: {
    item: {
      type: Object,
      default: null,
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
    mode: {
      type: String,
      default: null,
    },
    resetForm: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      caption: null,
      company_selected: null,
      company_options: [],
      company_loading: false,
      start_at: null,
      end_at: null,
      term_type_selected: 0,
      term_type_options: [
        { text: "برای داوطلبان", value: 0 },
        { text: "برای همکاران", value: 1 },
      ],
      license_type_selected: null,
      cooperation_type_selected: null,
      limit_registration_selected: [],
      limit_registration_options: [],
      limit_registration_loading: false,
      azmoon_selected: [],
      azmoon_options: [],
      azmoon_loading: false,
      pre_role_selected: [],
      final_role_selected: [],
      link_show: false,
      pre_register_code: null,
      link_caption: null,
      register_type_selected: 0,
      register_type_options: [
        { text: "ثبت نام بدون کد", value: 0 },
        { text: "ثبت نام با کد", value: 1 },
      ],
      link_register_code_caption: null,
      register_condition: null,
      link_check_national_code: false,
      check_two_step_verification: false,
      auto_login: false,
      status_selected: null,
      status_loading: false,
      description: null,
      generateRoleSelectedOfTreePage: false,
      termTimeStatus: true,
    };
  },
  computed: {
    license_type_options() {
      return renderEumOptions("term_license");
    },
    cooperation_type_options() {
      return renderEumOptions("cooperation_kind");
    },
    status_options() {
      return renderEumOptions("term_status");
    },
    registrationUrl() {
      const routerData = this.$router.resolve({
        name: "register-authentication",
        params: { code: this.pre_register_code },
      });
      return window.location.origin + routerData.href;
    },
    twoStepAlert() {
      return "با غیر فعال سازی تایید دو مرحله ای ثبت نام‌های این دوره برای لاگین لزوم به طی کردن فرایند تایید دو مرحله ای توسط تلفن همراه را نخواهند داشت ولی می توان از طریق لیست کاربری بعدا این امکان را بصورت تک تک برای هر کاربر فعال نمود.";
    },
  },
  watch: {
    item(value) {
      value && this.fetchData();
    },
    resetForm(value) {
      value && this.resetFormData();
    },
    term_type_selected() {
      if (this.mode === "edit") return;
      this.license_type_selected = null;
      this.cooperation_type_selected = null;
      this.limit_registration_selected = [];
    },
    register_type_selected() {
      if (this.mode === "edit") return;
      this.link_register_code_caption = null;
      this.register_condition = null;
      this.link_check_national_code = false;
    },
    end_at(value) {
      const endTime = new Date(value).getTime();
      const nowTime = new Date().getTime();
      this.$emit("updateTermDate", endTime < nowTime);
    },
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    copy,
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;
      let payload = {
        caption: this.caption,
        company_code: pathOr(null, ["code"], this.company_selected),
        start_date: this.start_at,
        end_date: this.end_at,
        status: pathOr(null, ["value"], this.status_selected),
        license_id: !this.term_type_selected
          ? pathOr(null, ["value"], this.license_type_selected)
          : null,
        cooperation_id: this.term_type_selected
          ? pathOr(null, ["value"], this.cooperation_type_selected)
          : null,
        limit_registration: !this.term_type_selected
          ? this.limit_registration_selected.map((item) =>
              pathOr(null, ["id"], item)
            )
          : null,
        azmoon_id: this.azmoon_selected.map((item) =>
          pathOr(null, ["id"], item)
        ),
        role_code: pathOr(null, ["0", "code"], this.pre_role_selected),
        final_role_code: pathOr(null, ["0", "code"], this.final_role_selected),
        link_show: this.link_show ? 1 : 0,
        link_caption: this.link_caption,
        link_register_by_code: this.register_type_selected,
        link_register_code_caption: this.register_type_selected
          ? this.link_register_code_caption
          : null,
        register_condition: this.register_condition,
        link_check_national_code: this.register_type_selected
          ? this.link_check_national_code
            ? 1
            : 0
          : null,
        two_step_verification: this.check_two_step_verification ? 1 : 0,
        direct_login: this.auto_login ? 1 : 0,
        description: this.description,
      };
      this.$emit("submit", payload);
    },
    close() {
      this.$emit("close");
    },
    resetFormData() {
      this.$v.$reset();
    },
    updatePreRoleSelected(data) {
      this.pre_role_selected = data;
    },
    updateFinalRoleSelected(data) {
      this.final_role_selected = data;
    },
    async getCompanyCombo(query) {
      if (!query || query.length < 2) {
        return;
      }
      if (query.length > 2) {
        this.company_options = [];
      }

      try {
        this.company_loading = true;
        const url = `${this.$config.api_url}${this.$config.profile.company_combo}?search_txt=${query}`;
        const response = await this.$httpService.get(url);
        this.company_options = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.company_loading = false;
      }
    },
    async getAzmoonCombo(query) {
      if (!query || query.length < 2) {
        return;
      }
      if (query.length > 2) {
        this.azmoon_options = [];
      }

      try {
        this.azmoon_loading = true;
        const url = `${this.$config.api_url}${this.$config.profile.azmoon_execute_combo}?search_txt=${query}`;
        const response = await this.$httpService.get(url);
        this.azmoon_options = [...pathOr([], ["data", "data"], response)].map(
          (item) => {
            return {
              caption: `${pathOr("", ["id"], item)} - ${pathOr(
                "",
                ["caption"],
                item
              )}`,
              id: pathOr(null, ["id"], item),
            };
          }
        );
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.azmoon_loading = false;
      }
    },
    async getTermCombo(query) {
      if (!query || query.length < 2) {
        return;
      }
      if (query.length > 2) {
        this.limit_registration_options = [];
      }

      try {
        this.limit_registration_loading = true;
        const url = `${this.$config.api_url}${this.$config.profile.term_combo}?search_txt=${query}`;
        const response = await this.$httpService.get(url);
        this.limit_registration_options = pathOr(
          [],
          ["data", "data"],
          response
        ).map((item) => {
          return {
            caption: `${pathOr("", ["id"], item)} - ${pathOr(
              "",
              ["caption"],
              item
            )}`,
            id: pathOr(null, ["id"], item),
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.limit_registration_loading = false;
      }
    },
    fetchData() {
      if (this.item && Object.keys(this.item).length) {
        this.caption = this.item.caption;
        this.company_selected = {
          name: pathOr(null, ["company", "caption"], this.item),
          code: pathOr(null, ["company", "id"], this.item),
        };
        this.start_at = pathOr(null, ["start_date", "gregorian"], this.item);
        this.end_at = pathOr(null, ["end_date", "gregorian"], this.item);
        this.status_selected = {
          text: pathOr(null, ["status", "caption"], this.item),
          value: pathOr(null, ["status", "id"], this.item),
        };
        this.term_type_selected = this.item.license ? 0 : 1;
        this.license_type_selected = {
          text: pathOr(null, ["license", "caption"], this.item),
          value: pathOr(null, ["license", "id"], this.item),
        };
        this.cooperation_type_selected = {
          text: pathOr(null, ["cooperation", "caption"], this.item),
          value: pathOr(null, ["cooperation", "id"], this.item),
        };
        this.limit_registration_selected = this.item.limit_registration
          ? [...this.item.limit_registration]
          : [];
        this.azmoon_selected = this.item.azmoon_id
          ? [...this.item.azmoon_id]
          : [];
        this.pre_role_selected = this.item.role ? [this.item.role] : [];
        this.final_role_selected = this.item.final_role
          ? [this.item.final_role]
          : [];
        this.link_show = pathOr(false, ["link_show"], this.item);
        this.pre_register_code = pathOr(null, ["pre_register_code"], this.item);
        this.link_caption = pathOr(null, ["link_caption"], this.item);
        this.register_type_selected = this.item.link_register_by_code ? 1 : 0;
        this.link_register_code_caption = pathOr(
          null,
          ["link_register_code_caption"],
          this.item
        );
        this.register_condition = pathOr(
          null,
          ["register_condition"],
          this.item
        );
        this.link_check_national_code = pathOr(
          false,
          ["link_check_national_code"],
          this.item
        );
        this.check_two_step_verification = pathOr(
          false,
          ["two_step_verification"],
          this.item
        );
        this.auto_login = pathOr(false, ["direct_login"], this.item);

        this.description = pathOr(null, ["description"], this.item);
        /* guidance: fetch data in treePage component */
        this.generateRoleSelectedOfTreePage = true;
      }
    },
    removeItemOfLimitRegistration(item) {
      this.limit_registration_selected = [
        ...this.limit_registration_selected.filter((row) => row.id !== item.id),
      ];
    },
    removeItemOfAzmoonSelected(item) {
      this.azmoon_selected = [
        ...this.azmoon_selected.filter((row) => row.id !== item.id),
      ];
    },
  },
};
</script>
